var path = 'public/app/plugins/panel/text/module.html';
var html = "<p class=\"markdown-html panel-text-content\" ng-bind-html=ctrl.content ng-show=ctrl.content>\n</p>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;